<template>
  <div class="CopyRight">Copyright © 2012 恒安标准人寿保险有限公司 </div>
  <!-- 津ICP备05010558号 -->
</template>

<script>
// 引入api模块
import api from '@/modules/api'
export default {
  //        组件名称
  name: 'CopyRight',
  //        初始化数据
  data () {
    return {      
    }
  },
  //        方法集
  methods: {
   
  },
  //        进入加载
  created () {}
}
</script>
<style scoped>
.CopyRight{color: #9E9FA0; text-align: center; font-size: 12px; height: 40px; line-height: 40px;}

</style>



// WEBPACK FOOTER //
// src/layout/Footer.vue